import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"

import NewsletterOverview from "./Overview"
import NewsletterSubscribers from "./Subscribers"
import NewsletterReleases from "./Releases"
import NewsletterTemplates from "./Templates"
import NewsletterSettings from "./Settings"
import NewsletterDiagnostics from "./Diagnostics"

const Newsletter = () => {
  return (
    <SidePanelLayout
      menuName="AdminNewsletterMenu"
      tabs={{
        overview: NewsletterOverview,
        subscribers: NewsletterSubscribers,
        releases: NewsletterReleases,
        templates: NewsletterTemplates,
        settings: NewsletterSettings,
        diagnostics: NewsletterDiagnostics,
      }}
    />
  )
}

export default Newsletter